/**
 * Creates a "fake" reference to a feature to be exported via the public API of the core. This
 * allows extensions to reference runtime core dependencies in a type-safe way without needing to
 * bundle them at build time (thus avoiding duplication/redundancy in extensions packages).
 */
var makeExternalRef = function (name) {
    return {
        name: name,
    };
};
export { makeExternalRef };
//# sourceMappingURL=makeExternalRef.js.map